const breakpoints = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
};

export function toPixel(breakpoint) {
  if (typeof breakpoints[breakpoint] === "undefined") {
    throw new Error(`Breakpoint ${breakpoint} is undefined`);
  }

  return breakpoints[breakpoint];
}
